export default "__VITE_ASSET__6a70ca76__"